/*
 * @Description: 
 * @Autor: wk
 * @Date: 2019-05-18 10:42:34
 * @LastEditors: wk
 * @LastEditTime: 2019-11-10 10:40:19
*/
/**
 * URL 映射
 */
let mapper = {
  w: 'wmsadmin/admin'
}
const prefix = process.env.NODE_ENV === 'development' ? 'api' : ''
mapper = Object.keys(mapper).reduce((o, k) => {
  o[k] = `${prefix}/${mapper[k]}`
  return o
}, {})

export default (url) => {
  // mocks 不做映射
  if (url.indexOf('mocks') >= 0 && url.indexOf('mocks') < 2) {
    return url
  }
  if (/^http|https/.test(url)) return url // 处理部分接口需要写死请求地址，不需要做地址转换
  const arr = url.split('/')
  // 如果找到匹配的
  const matchValue = arr.length > 2 && mapper[arr[1]]
  if (matchValue) {
    return url.replace(arr[1], matchValue)
  }
  if (url.charAt(0) === '/') {
    url = `/${prefix}${url}`
  } else {
    url = `/${prefix}/${url}`
  }
  url = url.replace('//', '/')
  return url
}
